import axios from 'axios';

import {
  TEMPLATES_LIST_REQUEST,
  TEMPLATES_LIST_SUCCESS,
  TEMPLATE_DETAILS_SUCCESS,
  TEMPLATE_DETAILS_REQUEST,
  TEMPLATE_SAVE_REQUEST,
  TEMPLATE_SAVE_SUCCESS,
  TEMPLATE_DELETE_REQUEST,
  TEMPLATE_DELETE_SUCCESS,
  TEMPLATE_GENERATE_MESSAGE_REQUEST,
} from '@/store/actions/message-templates';

import i18n from '@/i18n';

const state = {
  templatesList: {
    items: null,
    totalCount: 0,
    loading: false,
  },
  templateDetails: {
    template: null,
    loading: false,
    saveLoading: false,
  },
};

const getters = {
  templatesList: () => state.templatesList,
  templateDetails: () => state.templateDetails,
};

const actions = {
  [TEMPLATES_LIST_REQUEST]({ commit }, filters) {
    commit(TEMPLATES_LIST_REQUEST);
    return axios.post(
      '/insurance/message-template/list',
      // No pagination UI yet, so default to a high limit rather than the backend's page-size-10
      // default — otherwise pickers/lists would silently only show the 10 most recent templates.
      { limit: 1000, ...filters },
      { headers: { 'X-Locale': i18n.locale } },
    )
      .then((resp) => {
        commit(TEMPLATES_LIST_SUCCESS, resp.data);
        return resp.data;
      })
      .catch((err) => {
        commit(TEMPLATES_LIST_REQUEST);
        return Promise.reject(err.response.data);
      });
  },
  [TEMPLATE_DETAILS_REQUEST]({ commit }, templateId) {
    commit(TEMPLATE_DETAILS_REQUEST);
    return axios.post(
      '/insurance/message-template/detail',
      { templateId },
      { headers: { 'X-Locale': i18n.locale } },
    )
      .then((resp) => {
        commit(TEMPLATE_DETAILS_SUCCESS, resp.data);
        return resp.data;
      })
      .catch((err) => {
        commit(TEMPLATE_DETAILS_REQUEST);
        return Promise.reject(err.response.data);
      });
  },
  [TEMPLATE_SAVE_REQUEST]({ commit }, template) {
    commit(TEMPLATE_SAVE_REQUEST);
    return axios.post(
      '/insurance/message-template/save',
      {
        ...template,
      },
      { headers: { 'X-Locale': i18n.locale } },
    )
      .then((resp) => {
        commit(TEMPLATE_SAVE_SUCCESS, resp.data);
        return resp.data;
      })
      .catch((err) => {
        commit(TEMPLATE_SAVE_REQUEST);
        return Promise.reject(err.response.data);
      });
  },
  [TEMPLATE_DELETE_REQUEST]({ commit }, templateId) {
    commit(TEMPLATE_DELETE_REQUEST);
    return axios.post(
      '/insurance/message-template/delete',
      { templateId },
      { headers: { 'X-Locale': i18n.locale } },
    )
      .then(() => {
        commit(TEMPLATE_DELETE_SUCCESS);
        return true;
      })
      .catch((err) => {
        commit(TEMPLATE_DELETE_REQUEST);
        return Promise.reject(err.response.data);
      });
  },
  // Resolves a template into a ready-to-send message for a specific chat, given the page
  // it's being sent from (LEAD/REQUEST/PROFILE/HR) and that entity's id — mirrors the
  // request/response shape of CLIENTS_CHAT_GET_IMPROVED_TEXT. Contract documented for
  // backend in docs/message-template-generate-api.md.
  [TEMPLATE_GENERATE_MESSAGE_REQUEST](context, {
    templateId, type, entityId, conversationId,
  }) {
    return axios.post(
      '/insurance/message-template/generate',
      {
        templateId, type, entityId, conversationId,
      },
      { headers: { 'X-Locale': i18n.locale } },
    )
      .then((resp) => resp.data.text)
      .catch((err) => Promise.reject(err.response.data));
  },
};

const mutations = {
  [TEMPLATES_LIST_REQUEST]: (state) => {
    state.templatesList.loading = !state.templatesList.loading;
  },
  [TEMPLATES_LIST_SUCCESS]: (state, resp) => {
    state.templatesList.loading = false;
    state.templatesList.items = resp.items;
    state.templatesList.totalCount = resp.totalCount;
  },
  [TEMPLATE_DETAILS_REQUEST]: (state) => {
    state.templateDetails.template = null;
    state.templateDetails.loading = !state.templateDetails.loading;
  },
  [TEMPLATE_DETAILS_SUCCESS]: (state, resp) => {
    state.templateDetails.loading = false;
    state.templateDetails.template = resp;
  },
  [TEMPLATE_SAVE_REQUEST]: (state) => {
    state.templateDetails.saveLoading = !state.templateDetails.saveLoading;
  },
  [TEMPLATE_SAVE_SUCCESS]: (state, resp) => {
    state.templateDetails.saveLoading = false;
    state.templateDetails.template = resp;
  },
  [TEMPLATE_DELETE_REQUEST]: (state) => {
    state.templateDetails.saveLoading = !state.templateDetails.saveLoading;
  },
  [TEMPLATE_DELETE_SUCCESS]: (state) => {
    state.templateDetails.saveLoading = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
